import styled from 'styled-components';

import { Typography } from '@interstate/components/Typography';
import { AccordionDetails } from '@interstate/components/AccordionGroup';
import { TableCell } from '@interstate/components/SimpleTable';
import type { BaseDealBreakpoint } from '../../../utils/useBaseDealBreakpoint';

export const StyledTableCell = styled.div<{ $textAlign?: string; $minWidth?: string; $marginTop?: string }>`
    min-width: ${(props) => props.$minWidth || '3.125rem'};
    text-align: ${(props) => props.$textAlign || 'left'};
    margin-top: ${(props) => props.$marginTop || '0.3rem'};
`;

export const StyledTableCellBaseWithoutBorder = styled(TableCell)<{
    $width?: string;
    $alignContent?: string;
    $lineHeight?: string;
}>`
    align-content: ${(props) => props.$alignContent || 'center'};
    border-bottom-style: unset !important;
    padding: 0 0.8rem !important;
    width: ${(props) => props.$width || 'auto'};
    ${(props) => props.$lineHeight && `line-height: ${props.$lineHeight} !important;`}
`;

/* istanbul ignore next */
export const StyledTableCellWithBorder = styled(TableCell)<{ $width?: string }>`
    align-content: center;
    padding: 11px 9px !important;
    width: ${(props) => props.$width || 'auto'};
    border-bottom-style: 1px solid black !important;
`;

export const TypoRightAligned = styled(Typography)`
    text-align: right;
`;

export const TaxDetailsBaseContainer = styled(AccordionDetails)<{ BaseBreakPoint: BaseDealBreakpoint }>`
    max-width: 42rem;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 0 !important;

    @media (max-width: ${(props) => props.BaseBreakPoint.SMALL}) {
        width: 100%;
    }
`;

export const TaxOverrideContainer = styled.div`
    margin-top: auto;
`;
